import { Plugin } from "@ckeditor/ckeditor5-core";
import ApplyCBTPBTCommand from "./CBTPBTCommand";

export default class CBTPBTEditing extends Plugin {
  init() {
    const editor = this.editor;

    this._defineSchema();
    this._defineConverters();

    editor.commands.add("applyCBTPBT", new ApplyCBTPBTCommand(this.editor));

    if (editor.plugins.has("TrackChangesEditing")) {
      const trackChangesEditing = editor.plugins.get("TrackChangesEditing");
      trackChangesEditing.enableCommand("applyCBTPBT");
    }
  }

  _defineConverters() {
    const editor = this.editor;
    const conversion = editor.conversion;

    conversion.elementToElement({
      model: "cbt",
      view: {
        attributes: {
          title: "CBT Text",
        },
        classes: "CBT",
        name: "span",
      },
    });
    conversion.elementToElement({
      model: "pbt",
      view: {
        attributes: {
          title: "PBT Text",
        },
        classes: "PBT",
        name: "span",
      },
    });
  }

  _defineSchema() {
    const schema = this.editor.model.schema;

    schema.register("cbt", {
      allowContentOf: "$block",
      allowIn: "$block",
      isInline: true,
    });
    schema.setAttributeProperties("cbt", {
      isFormatting: true,
      copyOnEnter: false,
    });

    schema.register("pbt", {
      allowContentOf: "$block",
      allowIn: "$block",
      isInline: true,
    });
    schema.setAttributeProperties("pbt", {
      isFormatting: true,
      copyOnEnter: false,
    });
  }
}
